import React from 'react';

import type { MapType } from '@strava/mre';

import { MAP_TYPE_ANALYTICS_VALUES, MAP_TYPES } from '../../constants';
import { useMRE } from '../../hooks/useMRE';
import { useMREState } from '../../hooks/useMREState';

import styles from './MapTypeControl.module.scss';

export const MapTypeControl = () => {
  const { track, t } = useMRE();
  const { mapType, setMapType } = useMREState();

  const handleChange = (type: MapType) => {
    setMapType(type);

    // Note: We want to use a string value for the map type e.g. `satellite` in analytics
    // in order to match legacy analytics events use in Mapbox version.
    const mapTypeAnalyticsValue = MAP_TYPE_ANALYTICS_VALUES[type];

    if (!track || !mapTypeAnalyticsValue) {
      return;
    }

    track({
      action: 'click',
      element: 'map_type',
      properties: {
        map_type: mapTypeAnalyticsValue
      }
    });
  };

  if (mapType === null) {
    return null;
  }

  return (
    <div className={styles.mapTypeControl}>
      <select
        className={styles.select}
        title={t('mre.style_control.title')}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          handleChange(Number(e.target.value) as MapType)
        }
        value={mapType}
        data-testid="mre-map-style-select"
      >
        {Object.values(MAP_TYPES).map((value) => (
          <option key={value} value={value}>
            {t(`mre.style_control.map_type_${value}`)}
          </option>
        ))}
      </select>
    </div>
  );
};
